<template>
  <div>
    <div class="new-btn-wrap">
      <!-- 合同通过审批才能新建回款 -->
      <auth-button code="HTXJHK" v-if="contract.state === 1" type="primary" size="mini" icon="el-icon-plus" @click="newReceipt">新建回款</auth-button>
    </div>
    <new-table ref="payTableRef" :data="tableData" :columns="columns" :pages="pages"></new-table>
    <view-record-detail ref="viewDetailRef" :items="detailItems"></view-record-detail>
    <new-receipt-record ref="newReceiptRef" @save="saveReceipt" />
  </div>
</template>
<script>
import { ContractApis } from "@/apis";
import NewTable from "@/components/new-table";
import ViewRecordDetail from "./view-record-detail";
import { AuditState, AuditStateVal } from "@/utils/enum";
// import { Popup } from "@maidi/common";
import NewReceiptRecord from "./new-receipt-record.vue";

export default {
  name: "detail-receipt-record",
  props: { contract: Object },
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        { label: "回款编号", prop: "collectionNo" },
        { label: "回款金额", prop: "collectionAmount" },
        { label: "回款期数", prop: "collectionPeriod" },
        { label: "回款方式", prop: "collectionModeName" },
        { label: "负责人", prop: "chargeName" },
        { label: "状态", prop: "auditState", render: (h, { row }) => <audit-state-text state={row.state} /> },
        { label: "回款日期", prop: "collectionDate" },
        {
          label: "操作",
          width: "120",
          render: (h, { row }) => {
            const isRefuse = row.state === AuditStateVal.refuse; // 被拒绝
            const isWithdraw = row.state === AuditStateVal.withdraw; // 已撤销
            return (
              <span>
                <el-button type="text" onClick={() => this.viewDetail(row)}>
                  查看
                </el-button>
                {isRefuse && (
                  <auth-button code="HTBJHK" size="mini" type="text" onClick={() => this.editReceipt(row)}>
                    编辑
                  </auth-button>
                )}
                {isWithdraw && (
                  <auth-button code="HTSCHK" size="mini" type="text" onClick={() => this.deleReceipt(row.id)}>
                    删除
                  </auth-button>
                )}
              </span>
            );
          },
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          currentChange: this.pageChange,
          sizeChange: this.sizeChange,
        },
      },
      detailItems: [],
    };
  },
  mounted() {
    this.getReceiptList();
    this.initDetailItems();
  },
  methods: {
    initDetailItems() {
      const items = [
        { label: "客户名称", prop: "customerName" },
        { label: "合同编号", prop: "contractNo" },
        { label: "合同名称", prop: "contractName" },
        { label: "合同金额", prop: "contractAmount" },
        ...this.columns,
        { label: "备注", type: "fullWidth", prop: "remark" },
      ];
      items.splice(-2, 1); // 删除操作
      this.detailItems = items;
    },
    // 回款计划
    getReceiptList() {
      const { currentPage, pageSize } = this.pages.props;
      const params = { contractId: this.contract.id, pageIndex: currentPage, pageSize };
      ContractApis.getReceiptRecords(params).then((res) => {
        res.data.forEach((i) => {
          i.contractName = this.contract.contractName;
          i.customerName = this.contract.customerName;
          i.contractNo = this.contract.contractNo;
          i.contractAmount = this.contract.contractAmount;
          i.chargeName = this.contract.chargeName;
          i.collectionDate = i.collectionDate && i.collectionDate.slice(0, 11);
          i.auditState = AuditState[i.state];
          i.attachList = [];
        });
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    async newReceipt() {
      const row = {};
      this.initForm(row);
      this.$refs.newReceiptRef.show(row);
    },
    initForm(row) {
      row.customerId = this.contract.customerId;
      row.customerName = this.contract.customerName;
      row.contractId = this.contract.id;
      row.contractAmount = this.contract.contractAmount;
      row.contractNo = this.contract.contractNo;
    },
    editReceipt(row) {
      this.initForm(row);
      this.$refs.newReceiptRef.show(row);
    },
    viewDetail(row) {
      ContractApis.getRecordAttachList(row.id).then((res) => {
        row.attachList = res;
      });
      this.$refs.viewDetailRef.show(row);
    },
    async deleReceipt(id) {
      await this.$confirm("确定要删除该回款吗？", "注意", { type: "warning" });
      await ContractApis.deleReceiptRecord(id);
      this.$message.success("删除成功!");
      const index = this.tableData.findIndex((i) => i.id === id);
      this.tableData.splice(index, 1);
    },
    pageChange(p) {
      this.pages.props.currentPage = p;
      this.getReceiptList();
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.pageChange(1);
    },
    saveReceipt() {
      this.pageChange(1);
    },
  },
  components: { NewTable, ViewRecordDetail, NewReceiptRecord },
};
</script>
